export default "__VITE_PUBLIC_ASSET__f02c3c68__"